"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "2.27.0", "build_date": "2021-04-08T12:08:50.814Z", "build_branch": "2.27.0", "build_commit": "2b3007b13b9e6d1c2e6b00f338875789b0a27210" };
